module.exports = __webpack_public_path__ + "media/application/images/svgs/chevrons-down-1096cd99cc15a35dab26206f658f74fb.svg";